module.exports = __webpack_public_path__ + "img/icone-morte__primary-color.bd858ac2.png";